<template>
  <div class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
    <div class="container-fluid app-navbar-shell">
      <a class="navbar-brand" :href="brand.href">{{ brand.label }}</a>
      <div class="navbar-collapse collapse">
        <ul class="nav navbar-nav">
          <li v-for="item in items" :key="item.label" class="nav-item">
            <a :href="item.href" class="nav-link" :class="{ active: !!item.active }">
              {{ item.label }}
            </a>
          </li>
        </ul>

        <ul class="nav navbar-nav navbar-right navbar-account-nav">
          <li class="nav-item navbar-account-name">
            <span class="badge" :class="account.badgeClass || 'badge-primary'">{{ account.label }}</span>
          </li>
          <li v-if="logout" class="nav-item">
            <a :href="logout.href" class="nav-link">{{ logout.label }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  brand: {
    type: Object,
    default: () => ({ label: "SCC", href: "/" })
  },
  items: {
    type: Array,
    default: () => []
  },
  account: {
    type: Object,
    default: () => ({ label: "Guest User", badgeClass: "badge-secondary" })
  },
  logout: {
    type: Object,
    default: null
  }
})
</script>
